import { MESSAGE_TYPE } from './../Providers/FloatMessage'


const FloatMessage = ({ msg, onCloseClick, onExitAnimationEnd }) => {

    if (!msg || !msg.text) return null

    const { type, text, closing, id } = msg

    // Clases base según el tipo
    const baseClass =
        type === MESSAGE_TYPE.SUCCESS ? "FloatMessage--Success" :
        type === MESSAGE_TYPE.BAD     ? "FloatMessage--Bad"     :
        type === MESSAGE_TYPE.INFO    ? "FloatMessage--Info"    :
        type === MESSAGE_TYPE.WARNING ? "FloatMessage--Warning" :
        ""

    // Flags de animación entrada/salida
    const animClass = closing ? "is-exiting" : "is-entering"


    return (
        <div className="FloatMessage" key={id}>
            <div
                className={`${baseClass} ${animClass}`}
                onAnimationEnd={(e) => {
                    // Sólo al terminar animación de salida disparamos el remove
                    if (closing && e.animationName === "floatMessageOut") onExitAnimationEnd();
                }}>
                    {/* Botón para cerrar modal */}
                    {/* <button className={`${baseClass}__CloseButton`} onClick={onCloseClick}><i className="bi bi-x"></i></button> */}

                    <p className={`${baseClass}__Text`}>
                        {type === MESSAGE_TYPE.SUCCESS && <i className="bi bi-check-circle"></i>} 
                        {type === MESSAGE_TYPE.BAD     && <i className="bi bi-x-circle"></i>}
                        {type === MESSAGE_TYPE.INFO    && <i className="bi bi-info-circle"></i>}
                        {type === MESSAGE_TYPE.WARNING && <i className="bi bi-exclamation-triangle"></i>}{" "}
                        {text}
                    </p>

                    {/* {type === messageType.SUCCESS && (
                        <div className="FloatMessage--Success">
                            <button className="FloatMessage--Success__CloseButton"><i className="bi bi-x"></i></button>

                            <p className="FloatMessage--Success__Text"><i className="bi bi-check-circle"></i> {text}</p>
                        </div>
                    )}

                    {type === messageType.BAD && (
                        <div className="FloatMessage--Bad">
                            <button className="FloatMessage--Bad__CloseButton"><i className="bi bi-x"></i></button>

                            <p className="FloatMessage--Bad__Text"><i className="bi bi-x-circle"></i> {text}</p>
                        </div>
                    )}

                    {type === messageType.INFO && (
                        <div className="FloatMessage--Info">
                            <button className="FloatMessage--Info__CloseButton"><i className="bi bi-x"></i></button>

                            <p className="FloatMessage--Info__Text"><i className="bi bi-info-circle"></i> {text}</p>
                        </div>
                    )}

                    {type === messageType.WARNING && (
                        <div className="FloatMessage--Warning">
                            <button className="FloatMessage--Warning__CloseButton"><i className="bi bi-x"></i></button>

                            <p className="FloatMessage--Warning__Text"><i className="bi bi-exclamation-triangle"></i> {text}</p>
                        </div>
                    )} */}
            </div>
        </div>
    )
}

export { FloatMessage };